import React from "react";

interface NextGenImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  srcBase: string; // e.g. "/images/coins/BONK"
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  svg?: boolean; // if you have an SVG version
}

export const NextGenImage: React.FC<NextGenImageProps> = ({
  srcBase,
  alt,
  width,
  height,
  className,
  svg = false,
  ...props
}) => {
  // Defensive: Ensure srcBase is a non-empty string
  const safeSrcBase = typeof srcBase === 'string' && srcBase.trim() ? srcBase : '/images/coins/placeholder-coin';
  const safeAlt = typeof alt === 'string' && alt.trim() ? alt : 'coin icon';
  return (
    <picture>
      <source srcSet={`${safeSrcBase}.avif`} type="image/avif" />
      <source srcSet={`${safeSrcBase}.webp`} type="image/webp" />
      {svg && <source srcSet={`${safeSrcBase}.svg`} type="image/svg+xml" />}
      <img
        src={svg ? `${safeSrcBase}.svg` : `${safeSrcBase}.webp`}
        alt={safeAlt}
        width={width}
        height={height}
        loading="lazy"
        className={className}
        {...props}
      />
    </picture>
  );
};

export default NextGenImage; 